import Loadable from 'react-loadable';

import { LoadableLoadingPage } from 'pages/LoadableLoadingPage';

export const OrgDashboardAppLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "OrgDashboard" */
      './OrgDashboardApp.dynamic'
    ),
  loading: LoadableLoadingPage,
});
